import { createStore } from 'vuex'
import Vue from 'vue'
import Vuex from 'vuex'

const store = new Vuex.Store({
	state: {
		base_directory: '',
		baseURL: '',
		user: {
			id: null,
			image: null,
			name: null,
			last_name: null,
			phone: null,
			position: null,
			email: null,
			created_at: null,
			updated_at: null,
			role: null,
		},
		fields: [],
		options: [],
		mode: 'dev',
	},
	getters: {},
	mutations: {
		setUser(state, userData) {
			state.user = userData
		},
		setFields(state, fieldsData) {
			state.fields = fieldsData
		},
		setOptions(state, fieldsData) {
			state.options = fieldsData
		},
	},
	actions: {
		setUser({ commit }, userData) {
			commit('setUser', userData)
		},
		setFields({ commit }, fieldsData) {
			commit('setFields', fieldsData)
		},
		setOptions({ commit }, fieldsData) {
			commit('setOptions', fieldsData)
		},
	},
	modules: {},
})
export default store
